module.exports = "/packs/pattern-right-pink-ec22331712859071ea24e868735b752d.png";